import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CargandoService} from "../../services/cargando.service";
import {Subscription} from "rxjs";
import {SpinnerComponent} from "../spinner/spinner.component";

@Component({
    selector: 'app-spinner-serve',
    templateUrl: './spinner-serve.component.html',
    styleUrls: ['./spinner-serve.component.scss']
})
export class SpinnerServeComponent implements OnInit, OnDestroy {

    mostrar: boolean;
    subscripciones: Subscription[] = [];

    @ViewChild('spinner') spinner: SpinnerComponent;

    constructor(
        private readonly cargandoService: CargandoService,
    ) {
        this.mostrar = false;
    }

    ngOnInit() {
        this.escucharCargando();
    }

    escucharCargando() {
        const subscripcion = this.cargandoService.cargando$.subscribe(
            valor => {
                this.spinner.isSpinnerVisible = valor;
            },
        );
        this.subscripciones.push(subscripcion);
    }

    ngOnDestroy(): void {
        this.subscripciones.forEach(sub => sub.unsubscribe());
    }


}
